// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1XsqN","error":"Textarea_error___uXM8","readonly":"Textarea_readonly__3HrsZ","disabled":"Textarea_disabled__46K2G"};